import '/assets/styles/main.css';

import Alpine from 'alpinejs';
import AlpineFloatingUI from '@awcodes/alpine-floating-ui';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import LazyLoad from 'vanilla-lazyload';
import persist from '@alpinejs/persist';

import articles from './alpine/articles';
import collapse from './alpine/collapse';
import dialog from './alpine/dialog';
import header from './alpine/header';
import jobs from './alpine/jobs';
import menuMobileNavigation from './alpine/menuMobileNavigation';
import tabPeoples from './alpine/tabPeoples';
import tabs from './alpine/tabs';
import youtubeIframePlay from './alpine/youtubeIframePlay';

import horizontalScroll from './components/horizontalScroll';
import scrollbarWidth from './components/scrollbarWidth';
import smoothScroll from './components/smoothScroll';
import buttonScrollNextSection from './components/buttonScrollNextSection';
import marqueeInit from './components/marquee';
import swiper from './components/swiper';

window.lazyloadInstance = new LazyLoad();
window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(AlpineFloatingUI);
Alpine.plugin(persist);

Alpine.data('collapse', collapse);
Alpine.data('header', header);
Alpine.data('menuMobileNavigation', menuMobileNavigation);
Alpine.data('tabs', tabs);
Alpine.data('tabPeoples', tabPeoples);
Alpine.data('dialog', dialog);
Alpine.data('articles', articles);
Alpine.data('jobs', jobs);
Alpine.data('youtubeIframePlay', youtubeIframePlay);

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  horizontalScroll();
  smoothScroll();
  swiper();
  scrollbarWidth();
  buttonScrollNextSection();
  marqueeInit();
});
